var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.667v4.66l-3.5 3.51v1.83h-1v-1.83L8 14.317v-4.65h8zm0-6h-2v4h-4v-4H8v4h-.01C6.9 7.657 6 8.557 6 9.647v5.52l3.5 3.5v3h5v-3l3.5-3.51v-5.49c0-1.1-.9-2-2-2v-4z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDkuNjY2NjdWMTQuMzI2N0wxMi41IDE3LjgzNjdWMTkuNjY2N0gxMS41VjE3LjgzNjdMOCAxNC4zMTY3VjkuNjY2NjdIMTZaTTE2IDMuNjY2NjdIMTRWNy42NjY2N0gxMFYzLjY2NjY3SDhWNy42NjY2N0g3Ljk5QzYuOSA3LjY1NjY3IDYgOC41NTY2NyA2IDkuNjQ2NjdWMTUuMTY2N0w5LjUgMTguNjY2N1YyMS42NjY3SDE0LjVWMTguNjY2N0wxOCAxNS4xNTY3VjkuNjY2NjdDMTggOC41NjY2NyAxNy4xIDcuNjY2NjcgMTYgNy42NjY2N1YzLjY2NjY3WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgPdu as ReactComponent };